import { trpc } from '@/shared/api/trpc';

// Append a comment. Invalidation only — toasts belong at the ui/ call site.
//
// `onSettled` (not `onSuccess`): a failed attempt may still have landed (the
// response was lost, not the write), so the thread is re-read either way. That
// is safe precisely because the mutation is idempotent on `clientRequestId`.
export const useAddTicketComment = () => {
  const utils = trpc.useUtils();
  return trpc.support.commentAdd.useMutation({
    onSettled: (_data, _error, variables) => {
      if (variables?.ticketId) {
        utils.support.commentList.invalidate({ ticketId: variables.ticketId });
      }
    },
  });
};
